import { eachDayOfInterval, isSameDay, startOfMonth } from 'date-fns';

import getFromDate from './getFromDate';
import getToDate from './getToDate';

import type { WeekRange } from '~/ui/components/inputs/DatePicker/WeekPickerMUI';

/**
 * Converts a week range [start, end] to calendar state (selectedMonth, weekRange).
 * Handles weeks spanning two months correctly.
 */
const weekRangeToCalendarState = (range: WeekRange): { selectedMonth: Date; weekRange: number } => {
  const [weekStart] = range;
  const selectedMonth = startOfMonth(weekStart);
  const extendedStart = getFromDate(selectedMonth, true) as Date;
  const extendedEnd = getToDate(selectedMonth, true) as Date;
  const daysInterval = eachDayOfInterval({ start: extendedStart, end: extendedEnd });

  const dayIndex = daysInterval.findIndex(day => isSameDay(day, weekStart));
  const weekRange = dayIndex >= 0 ? Math.floor(dayIndex / 7) : 0;

  return { selectedMonth, weekRange };
};

export default weekRangeToCalendarState;
